export class HoldingReportData {
    constructor(holdingSummary, holdingDetails, searchData, Filterdata, sortData, IsSummarize, HoldingDataFlags) {
        this.HoldingSummary = holdingSummary;
        this.HoldingDetails = holdingDetails;
        this.SearchData = searchData;
        this.FilterData = Filterdata;
        this.SortData = sortData;
        this.IsSummarize = IsSummarize;
        this.HoldingDataFlags = HoldingDataFlags;
    }
}
export var ReportType;
(function (ReportType) {
    ReportType["PDF"] = "pdf";
    ReportType["PDF_SUMMARY"] = "pdf/summary";
    ReportType["PDF_DETAIL"] = "pdf/detail";
    ReportType["EXCEL"] = "excel";
})(ReportType || (ReportType = {}));
export var ReportName;
(function (ReportName) {
    ReportName["HOLDINGS"] = "holding";
    ReportName["SMALLCASE"] = "smallcase";
    ReportName["PNL"] = "pnl";
    ReportName["PNL_TRANSACTION_REPORT"] = "PNL_TRANSACTION_REPORT";
    ReportName["TAX"] = "tax";
    ReportName["DP"] = "dp";
    ReportName["POSITION"] = "position";
    ReportName["CONTRACT"] = "Contract notes";
    ReportName["MARGIN"] = "margin";
    ReportName["SUBSCRIPTION"] = "subscription Fees";
    ReportName["TRANSACTIONHISTORY"] = "transactionHistory";
    ReportName["ACCOUNTOVERVIEW"] = "AccountOverview";
    // DASHBOARD = "dashboard",
    ReportName["HDASHBOARD"] = "hdashboard";
    ReportName["PNLDASHBOARD"] = "pnldashboard";
    ReportName["LEDGER"] = "ledger";
    ReportName["DPBILLS"] = "DP Bills Report";
    ReportName["DPINTEREST"] = "Delayed Payment Interest";
    ReportName["TAX_HARVESTING"] = "Tax Harvetsing";
})(ReportName || (ReportName = {}));
export var EREPORTSCREENSTATE;
(function (EREPORTSCREENSTATE) {
    EREPORTSCREENSTATE["L1"] = "L1";
    EREPORTSCREENSTATE["L3"] = "L3";
})(EREPORTSCREENSTATE || (EREPORTSCREENSTATE = {}));
export var EDownloadeEmailReportSearchParamKeys;
(function (EDownloadeEmailReportSearchParamKeys) {
    EDownloadeEmailReportSearchParamKeys["ACCOUNT_ID"] = "accountId";
    EDownloadeEmailReportSearchParamKeys["ACCOUNT_IDs"] = "accountIds";
    EDownloadeEmailReportSearchParamKeys["FROM_DATE"] = "fromDate";
    EDownloadeEmailReportSearchParamKeys["TO_DATE"] = "toDate";
    EDownloadeEmailReportSearchParamKeys["DATE"] = "date";
    EDownloadeEmailReportSearchParamKeys["DP_ID"] = "dpId";
    EDownloadeEmailReportSearchParamKeys["DP_TYPE"] = "dpType";
    EDownloadeEmailReportSearchParamKeys["ACCOUNT_CODE"] = "accountCode";
    EDownloadeEmailReportSearchParamKeys["ASSET_TYPE"] = "assetType";
    EDownloadeEmailReportSearchParamKeys["SCRIP_IDENTIFIER"] = "scripIdentifier";
    EDownloadeEmailReportSearchParamKeys["UNDERLYING_ASSET"] = "underlyingAsset";
    EDownloadeEmailReportSearchParamKeys["ENTITY"] = "entity";
    EDownloadeEmailReportSearchParamKeys["IS_MTF"] = "isMtf";
    EDownloadeEmailReportSearchParamKeys["SEGMENT"] = "segment";
    EDownloadeEmailReportSearchParamKeys["LEDGER_TYPE"] = "ledgerType";
    EDownloadeEmailReportSearchParamKeys["SUB_TYPE"] = "subType";
    EDownloadeEmailReportSearchParamKeys["PDF"] = "pdf";
    EDownloadeEmailReportSearchParamKeys["EXCEL"] = "excel";
    EDownloadeEmailReportSearchParamKeys["EMAIL_IDS"] = "emailIds";
    EDownloadeEmailReportSearchParamKeys["FINANCIAL_YEAR"] = "financialYear";
    EDownloadeEmailReportSearchParamKeys["EMAIL_ID"] = "emailID";
    EDownloadeEmailReportSearchParamKeys["FILE_PATH"] = "filePath";
    EDownloadeEmailReportSearchParamKeys["EXPIRY_MONTH"] = "expiryMonth";
})(EDownloadeEmailReportSearchParamKeys || (EDownloadeEmailReportSearchParamKeys = {}));
